import React, {useState, useEffect} from 'react';
import {styled} from 'linaria/react'
import { sortObjectsByProperty, splitArrayIntoChunks } from '../../Core/Util/Helpers';
import BrandlistSkeleton from '../../Core/Skeletons/BrandlistSkeleton';
import Link from '../../Core/Link';

const BrandlistContainer = styled.div`
    &:nth-child(even) {
        background: #ececec;
    }

   ul {
      list-style: none;
      padding: 0;
      margin: 0;
   }

   li {
      list-style: none;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
   }

   .brand-letter {
      font-family: var(--font-industry);
      font-size: 4rem;
      color: #195178;
      font-weight: 700;
   }

   .brandslist-link {
      font-size: 22px;
      font-weight: 700;
      color: #000;
      text-decoration: none;
   }
`

const Brandlist = ({ brands }) => {
   const [brandList, setBrandList] = useState(null)

   useEffect(() => {
      setBrandList(brands)
   }, [setBrandList, brands])

   if(!brandList){
      return <BrandlistSkeleton></BrandlistSkeleton>
   }

   return (
      <>
         {Object.keys(brands)
            .sort()
            .map((key, i) => {
               const sortedBrands = sortObjectsByProperty(brandList[key], 'name')
               return (
                  <BrandlistContainer key={i} className="row py-32 mx-0 px-128">
                     <div className="col-3 col-md-2">
                        <div className="brand-letter">{key}</div>
                     </div>
                     <div className="col-9 col-md-10">
                        <div className="row">
                           {splitArrayIntoChunks(sortedBrands, 6)?.map(
                              (brandArray, i) => {
                                 return (
                                    <div key={i} className="col-12 col-sm-6 col-lg-4 col-xl-2">
                                       <ul>
                                          {brandArray?.map((brand, j) => {
                                             return (
                                                <li key={j}>
                                                   <Link
                                                      className="link link--vb brandslist-link" title={brand?.name}
                                                      to={
                                                         brand?.primaryRoute
                                                            ?.path
                                                      }
                                                   >
                                                      {brand?.name}
                                                   </Link>
                                                </li>
                                             )
                                          })}
                                       </ul>
                                    </div>
                                 )
                              }
                           )}
                        </div>
                     </div>
                  </BrandlistContainer>
               )
            })}
      </>
   )
}

export default Brandlist